import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            username: '',
            trainings: [],
            partners: [],
            selectedPartners: [],
            slots: [],
            slotsPerDay: [],
            slotFilter: '-1',
            usersCanReserveTrainingWithScanQr: false,
            fromDate : null,
            toDate: null,
            filter: '',
            totalPrice: 0,
            totalTrainings: 0,
            totalSlots: 0,
            weeklyReport: false,
            pagination: {
                page: 1,
                limit: 50,
                totalCount: 0
            },
            useProfilePictures: false,
            showVegaReport: false,
            showTotalPrice: false,
            showUserTrainingTypeOnTraining: false,
            shouldApproveReservedTraining: false,
            showAddKeyForTraining: false,
            showTrainingType: CONFIG_COMPANY.SHOW_TRAINING_TYPE_REPORT,
            showImagePreview: false,
            imageToPreviewUserId: 0,
            imageToPreview: "",
        }
    },
    methods: {
        load: load,
        loadByUser: loadByUser,
        clickSearch: clickSearch,
        clickSearchByUser: clickSearchByUser,
        openImage: openImage,
        generateHtmlFile: generateHtmlFile,
        generateHtmlFileWithPrices: generateHtmlFileWithPrices,
        keymonitor: keymonitor

    },

    computed: {
        filteredSlots(){
            return this.slotsPerDay;
        },
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.username = session.getUsername();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.showVegaReport = session.getConfig().enableVegaReport == null ? true : session.getConfig().enableVegaReport
        this.showTotalPrice = CONFIG_COMPANY.SHOW_TOTAL_PRICE_REPORT;
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures;
        this.usersCanReserveTrainingWithScanQr = session.getConfig().usersCanReserveTrainingWithScanQr != null && session.getConfig().usersCanReserveTrainingWithScanQr !== ""
        this.shouldApproveReservedTraining = session.getConfig().shouldApproveReservedTraining == null ? false : session.getConfig().shouldApproveReservedTraining
        this.showUserTrainingTypeOnTraining = CONFIG_COMPANY.SHOW_USER_TRAINING_TYPE_ON_TRAINING;
        this.showAddKeyForTraining = CONFIG_COMPANY.ADD_KEY_FOR_TRAINING;
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
            }
        },
        'slotFilter': function (newVal){
            this.pagination.page = 1;
            this.load()
        }
    }
}

function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
}

function clickSearchByUser() {
    this.pagination.page = 1;
    this.loadByUser()
}

function load() {
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        filter: '',
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.getTrainerReport(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
            _self.generateHtmlFileWithPrices(response.data, model.fromDate, model.toDate)
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

}

function loadByUser() {
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        filter: '',
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    AdminApiService.getTrainerReportByUser(model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
            _self.generateHtmlFileWithPrices(response.data, model.fromDate, model.toDate)
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })

}

function generateHtmlFileWithPrices(trainers, startDate, endDate){
    let _self = this;

    var csvFile = "";
    var priceByType = CONFIG_COMPANY.TRAINING_TYPE_PRICES != null ? CONFIG_COMPANY.TRAINING_TYPE_PRICES : {};
    const priceList = trainers.map(person => {
        const totalPricesByType = {};

        if(person.prices != null){
            for (const [type, prices] of Object.entries(person.prices)) {
                totalPricesByType[type] = prices.reduce((sum, price) => sum + price, 0);
            }
        }

        return {
            name: person.name,
            totalPricesByType
        };
    });

    var pricePercentage = CONFIG_COMPANY.TRAINING_SALARY_PERCENTAGE != null ? CONFIG_COMPANY.TRAINING_SALARY_PERCENTAGE : 1.0;



    //DODAVANJE DATUMA
    for(var i = 0; i < trainers.length; i++){
        csvFile = csvFile + trainers[i].name + ', ' + trainers[i].allSlotsCount + ", , , " + "\n";
        let slotCountsByType = trainers[i].slotCountsByType;
        let trainerName = trainers[i].name
        Object.entries(slotCountsByType).forEach(([type, count]) => {
            let trainerItemPrice = priceList.find(t => t.name === trainerName)
            var priceItem = trainerItemPrice != null && trainerItemPrice.totalPricesByType[type] != null ? trainerItemPrice.totalPricesByType[type] : 0;
            if(trainerItemPrice == null || trainerItemPrice.totalPricesByType[type] == null){
                pricePercentage = 1.0;
                priceItem = priceByType[type];
                if(priceItem != null){
                    priceItem = priceItem * count;
                }
            }
            csvFile = csvFile + " - " + ', ' + " - " + ", " + type + ", " + count + ", " + (priceItem * pricePercentage) + "\n"
        });
    }

    let listData = csvFile.split("\n")

    let title = LocService.t('label_trainer_report') + " " + startDate + " - " + endDate;
    let name = LocService.t('label_name');
    let total = LocService.t('label_report_total_slots');

    let typeSlot = LocService.t('label_report_type');
    let numberSlot = LocService.t('label_number_slots');
    let salaryPercentage = '' + pricePercentage * 100 + '%';
    let totalPrice = LocService.t('label_total_price') + ' ('+ salaryPercentage +') ';

    // Kreiranje HTML sadržaja
    let htmlContent = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid black; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }
            </style>
        </head>
        <body>
            <h2>${title}</h2>
            <table>
                <tr>
                    <th>${name}</th>
                    <th>${total}</th>
                    <th>${typeSlot}</th>
                    <th>${numberSlot}</th>
                    <th>${totalPrice}</th>
                </tr>`;

    // Dodavanje redova u tabelu
    listData.forEach(t => {
        if(t.trim().length > 0){
            let row = t.split(",")
            if (row[0] !== ' - ') { // primer: dodaj liniju posle 2. i 4. reda
                htmlContent += `
                <tr>
                    <td colspan="4" style="padding: 0;"><hr style="border: 0; border-top: 1px solid black; margin: 4px 0;"></td>
                </tr>`;
            }
            htmlContent += `
                <tr>
                    <td>${row[0]}</td>
                    <td>${row[1]}</td>
                    <td>${row[2]}</td>
                    <td>${row[3]}</td>
                    <td>${row[4]}</td>
                </tr>`;
        }
    });

    htmlContent += `
            </table>
        </body>
        </html>`;

    // Otvaranje u novom tabu
    let newWindow = window.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
}

function generateHtmlFile(trainers, startDate, endDate){
    let _self = this;

    var csvFile = "";

    //DODAVANJE DATUMA
    for(var i = 0; i < trainers.length; i++){
        csvFile = csvFile + trainers[i].name + ', ' + trainers[i].allSlotsCount + ", , " + "\n";
        let slotCountsByType = trainers[i].slotCountsByType;
        Object.entries(slotCountsByType).forEach(([type, count]) => {
            csvFile = csvFile + " - " + ', ' + " - " + ", " + type + ", " + count + "\n"
        });
    }

    let listData = csvFile.split("\n")

    let title = LocService.t('label_trainer_report') + " " + startDate + " - " + endDate;
    let name = LocService.t('label_name');
    let total = LocService.t('label_report_total_slots');

    let typeSlot = LocService.t('label_report_type');
    let numberSlot = LocService.t('label_number_slots');
    // Kreiranje HTML sadržaja
    let htmlContent = `
        <html>
        <head>
            <title>${title}</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid black; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; }
            </style>
        </head>
        <body>
            <h2>${title}</h2>
            <table>
                <tr>
                    <th>${name}</th>
                    <th>${total}</th>
                    <th>${typeSlot}</th>
                    <th>${numberSlot}</th>
                </tr>`;

    // Dodavanje redova u tabelu
    listData.forEach(t => {
        if(t.trim().length > 0){
            let row = t.split(",")
            if (row[0] !== ' - ') { // primer: dodaj liniju posle 2. i 4. reda
                htmlContent += `
                <tr>
                    <td colspan="4" style="padding: 0;"><hr style="border: 0; border-top: 1px solid black; margin: 4px 0;"></td>
                </tr>`;
            }
            htmlContent += `
                <tr>
                    <td>${row[0]}</td>
                    <td>${row[1]}</td>
                    <td>${row[2]}</td>
                    <td>${row[3]}</td>
                </tr>`;
        }
    });

    htmlContent += `
            </table>
        </body>
        </html>`;

    // Otvaranje u novom tabu
    let newWindow = window.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.pagination.page = 1;
        this.load();
    }
}


// WEBPACK FOOTER //
// ./src/components/TrainingReport/TrainerReport.js